/* A/B On-Page Snippet — wird async ins Theme geladen. Performance-neutral:
   blockiert nichts; auf Nicht-Test-Seiten passiert (außer 1 gecachtem Config-Fetch) nichts.
   Fail-open: jeder Fehler -> Original bleibt. Deploy-Ziel: HLP-Theme assets/ab-onpage.js */
(function () {
  'use strict';
  var BASE = 'https://new-era.cloud';
  var SHOP = 'hlp';
  var CACHE_KEY = 'ab_cfg_' + SHOP, CACHE_TTL = 60000;

  function isBot() { return /bot|crawl|spider|slurp|bing|google|yandex|baidu|duckduck|facebookexternal|headless|lighthouse|pingdom|uptime|monitor|preview/i.test(navigator.userAgent || ''); }
  function device() { return /mobile|android|iphone|ipod|tablet|ipad/i.test(navigator.userAgent || '') ? 'mobile' : 'desktop'; }
  function uuid() { return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2); }

  function getCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m.pop()) : null; }
  function setCookie(n, v, days) { var d = new Date(); d.setTime(d.getTime() + (days || 30) * 86400000); document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax'; }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function urlMatches(pattern, path) {
    if (!pattern || pattern === '*') return true;
    if (pattern.indexOf('*') !== -1) {
      try { return new RegExp('^' + pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$').test(path); } catch (e) { return false; }
    }
    return path.indexOf(pattern) !== -1;
  }
  function pickWeighted(vs) {
    var total = 0, i; for (i = 0; i < vs.length; i++) total += (Number(vs[i].weight) || 0);
    if (total <= 0) return vs[0];
    var r = Math.random() * total;
    for (i = 0; i < vs.length; i++) { r -= (Number(vs[i].weight) || 0); if (r <= 0) return vs[i]; }
    return vs[vs.length - 1];
  }

  function getConfig(previewSlug, cb) {
    if (previewSlug) { // QA-Vorschau: frisch + auch Entwürfe
      fetch(BASE + '/ab/config?shop=' + SHOP + '&preview=' + encodeURIComponent(previewSlug), { credentials: 'omit' })
        .then(function (r) { return r.json(); }).then(cb).catch(function () { cb({ experiments: [] }); });
      return;
    }
    var c = ss(CACHE_KEY);
    if (c) { try { var o = JSON.parse(c); if (Date.now() - o.t < CACHE_TTL) return cb(o.d); } catch (e) {} }
    fetch(BASE + '/ab/config?shop=' + SHOP, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) { ss(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); cb(d); })
      .catch(function () { cb({ experiments: [] }); });
  }

  function injectCss(id, css) { if (!css || document.getElementById(id)) return; var s = document.createElement('style'); s.id = id; s.textContent = css; (document.head || document.documentElement).appendChild(s); }
  function runJs(js) { if (!js) return; try { (new Function(js))(); } catch (e) { /* niemals die Seite brechen */ } }
  function post(path, body) { try { fetch(BASE + path, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () {}); } catch (e) {} }
  function tagCart(slug, key, vid) {
    var flag = 'ab_cart_' + slug; if (ss(flag)) return; ss(flag, '1');
    var attrs = {}; attrs['_ab_' + slug] = key + '|' + vid + '|' + device();
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {}); } catch (e) {}
  }

  var atcExps = [];
  function hookAddToCart() {
    function fire() { atcExps.forEach(function (e) { var f = 'ab_atc_' + e.slug; if (ss(f)) return; ss(f, '1'); post('/ab/event', { slug: e.slug, variantKey: e.key, visitorId: e.vid, type: 'add_to_cart', device: device() }); }); }
    var of = window.fetch;
    if (of && !of.__abHooked) {
      window.fetch = function (input) { try { var u = (typeof input === 'string') ? input : (input && input.url) || ''; if (/\/cart\/add(\.js)?/.test(u)) setTimeout(fire, 0); } catch (e) {} return of.apply(this, arguments); };
      window.fetch.__abHooked = true;
    }
    var oo = XMLHttpRequest.prototype.open;
    if (oo && !oo.__abHooked) {
      XMLHttpRequest.prototype.open = function (m, url) { try { if (/\/cart\/add(\.js)?/.test(url || '')) this.addEventListener('load', function () { setTimeout(fire, 0); }); } catch (e) {} return oo.apply(this, arguments); };
      XMLHttpRequest.prototype.open.__abHooked = true;
    }
  }

  function parsePreview() { var m = (location.search || '').match(/[?&]ab_preview=([^&]+)/); if (!m) return null; var p = decodeURIComponent(m[1]).split(':'); return p[1] ? { slug: p[0].toLowerCase(), key: p[1] } : null; }

  function run() {
    if (isBot()) return;
    var preview = parsePreview();
    getConfig(preview ? preview.slug : null, function (cfg) {
      var exps = (cfg && cfg.experiments) || [], path = location.pathname;
      exps.forEach(function (exp) {
        if (!urlMatches(exp.urlMatch, path)) return;
        var vs = exp.variants || []; if (!vs.length) return;
        var cookieName = exp.cookieName || ('ab_' + exp.slug);
        var chosen = null, vid = null, isNew = false, isPreview = false, j, k;

        if (preview && preview.slug === exp.slug) {
          for (j = 0; j < vs.length; j++) if (vs[j].key === preview.key) chosen = vs[j];
          if (!chosen) chosen = vs[0]; vid = 'preview'; isPreview = true;
        } else {
          var raw = getCookie(cookieName);
          if (raw) { try { var pr = JSON.parse(raw); for (k = 0; k < vs.length; k++) if (vs[k].key === pr.v) { chosen = vs[k]; vid = pr.id; } } catch (e) {} }
          if (!chosen) { chosen = pickWeighted(vs); vid = uuid(); isNew = true; setCookie(cookieName, JSON.stringify({ v: chosen.key, id: vid }), exp.cookieDays); }
        }

        var isControl = chosen.key === vs[0].key, hideEl = null;
        if (!isControl && exp.flickerSelector) { try { hideEl = document.querySelector(exp.flickerSelector); if (hideEl) { hideEl.style.visibility = 'hidden'; setTimeout(function () { if (hideEl) hideEl.style.visibility = ''; }, 1500); } } catch (e) {} }
        if (!isControl) { injectCss('ab-' + exp.slug, chosen.css); runJs(chosen.js); }
        if (hideEl) hideEl.style.visibility = '';

        if (!isPreview) {
          tagCart(exp.slug, chosen.key, vid);
          var seen = 'ab_seen_' + exp.slug;
          if (isNew || !ss(seen)) { ss(seen, '1'); post('/ab/expose', { slug: exp.slug, variantKey: chosen.key, visitorId: vid, isNew: isNew, path: path, referer: document.referrer || null }); }
          atcExps.push({ slug: exp.slug, key: chosen.key, vid: vid });
        }
      });
      if (atcExps.length) hookAddToCart();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
